import { ref } from "vue";
import { useStoreCompat } from "./useStoreCompat";

export function useFiltersActuationsReceived() {
  const store = useStoreCompat();

  const filterDropdown = ref({
    "exp_pre_TipoActuacion.TipoActuacionID": {
      optionValue: "value",
      optionLabel: "name",
      options: [],
    },
    "exp_pre_EstadoActuacion.TipoEstadoActuacionID": {
      optionValue: "value",
      optionLabel: "name",
      options: [
        { name: "En Curso", value: "En Curso" },
        { name: "Vencida", value: "Vencida" },
        { name: "Finalizada", value: "Finalizada" },
      ],
    },
    JuzgadoID: {
      optionValue: "JuzgadoID",
      optionLabel: "Nombre",
      options: [],
      refreshDropdown: async () => {
        await store.dispatch("siis/setJuzgados", true);
        filterDropdown.value["JuzgadoID"].options = store.state.siis.juzgados;
      },
      loadDropdown: async () => {
        await store.dispatch("siis/setJuzgados");
        filterDropdown.value["JuzgadoID"].options = store.state.siis.juzgados;
      },
    },
    RolesOficiales: {
      optionValue: "value",
      optionLabel: "name",
      options: [
        { value: "jefe de sumario", name: "Jefe de sumario" },
        { value: "jefe de dependencia", name: "Jefe de dependencia" },
        { value: "oficial sumariante", name: "Oficial sumariante" },
      ],
    },
    ModusOperandi: {
      optionValue: "Nombre",
      optionLabel: "Nombre",
      options: [],
      refreshDropdown: async () => {
        await store.dispatch("siis/setModusoperandi", true);
        filterDropdown.value["ModusOperandi"].options = store.state.siis.modusoperandi;
      },
      loadDropdown: async () => {
        await store.dispatch("siis/setModusoperandi");
        filterDropdown.value["ModusOperandi"].options = store.state.siis.modusoperandi;
      },
    },
    Articulo: {
      optionValue: "ArticulosID",
      optionLabel: "Numeroarticulo",
      options: [],
      refreshDropdown: async () => {
        await store.dispatch("siis/setArticulos", true);
        filterDropdown.value["Articulo"].options = store.state.siis.articulos;
      },
      loadDropdown: async () => {
        await store.dispatch("siis/setArticulos");
        filterDropdown.value["Articulo"].options = store.state.siis.articulos;
      },
    },
    Departamental: {
      optionValue: "DepartamentalID",
      optionLabel: "Nombre",
      options: [],
      refreshDropdown: async () => {
        await store.dispatch("siis/setDepartamentales", true);
        filterDropdown.value["Departamental"].options = store.state.siis.departamentales;
      },
      loadDropdown: async () => {
        await store.dispatch("siis/setDepartamentales");
        filterDropdown.value["Departamental"].options = store.state.siis.departamentales;
      },
    },
    Sitio: {
      optionValue: "TipoSitioID",
      optionLabel: "Nombre",
      options: [],
      refreshDropdown: async () => {
        await store.dispatch("siis/setSitio", true);
        filterDropdown.value["Sitio"].options = store.state.siis.sitio;
      },
      loadDropdown: async () => {
        await store.dispatch("siis/setSitio");
        filterDropdown.value["Sitio"].options = store.state.siis.sitio;
      },
    },
  });

  const filtersFields = ref([
    { name: "Actuaciones", field: "exp_pre_TipoActuacion.TipoActuacionID", hideOperators: true },
    { name: "Fecha de Creación", field: "createdAt", type: "date" },
    {
      name: "DNI Denunciante",
      field: "exp_pre_PersonaFisica.Dni",
      addFilter: {
        "exp_pre_ActuacionPersonaFisica.TipoRolPersonaFisicaID": [
          { operator: "CONTAINS", value: "Denunciante" },
        ],
      },
    },
    {
      name: "DNI Damnificado",
      field: "exp_pre_PersonaFisica.Dni",
      addFilter: {
        "exp_pre_ActuacionPersonaFisica.TipoRolPersonaFisicaID": [
          { operator: "CONTAINS", value: "Damnificado" },
        ],
      },
    },
    {
      name: "Afectado Telefono",
      field: "exp_pre_PersonaFisica.Telefono",
      addFilter: {
        "exp_pre_ActuacionPersonaFisica.Telefono": [],
      },
    },
    {
      name: "DNI Acusado",
      field: "exp_pre_PersonaFisica.Dni",
      addFilter: {
        "exp_pre_ActuacionPersonaFisica.TipoRolPersonaFisicaID": [
          { operator: "=", value: "Acusado" },
        ],
      },
    },
    {
      name: "Apodo",
      field: "exp_pre_PersonaFisica.Apodo",
      addFilter: {
        "exp_pre_ActuacionPersonaFisica.TipoRolPersonaFisicaID": [
          { operator: "=", value: "Acusado" },
        ],
      },
    },
    {
      name: "Estado",
      field: "exp_pre_EstadoActuacion.TipoEstadoActuacionID",
      addFilter: {
        ConUsuarioAsignado: [{ operator: "=", value: "true" }],
      },
      hideOperators: true,
    },
    {
      name: "Causa/Caratula",
      field: "exp_pre_Tipocausacaratula.TipocausacaratulaID",
    },
    {
      name: "Modus Operandi",
      field: "ModusOperandi",
      hideOperators: true,
    },
    {
      name: "Articulo",
      field: "Articulo",
      hideOperators: true,
    },
    {
      name: "Usuario por Rol",
      field: "RolesOficiales",
      hideOperators: true,
    },
    {
      name: "Sitio",
      field: "Sitio",
      hideOperators: true,
    },
  ]);

  const orderedDropdown = () => {
    return Object.keys(filterDropdown.value)
      .sort()
      .reduce((acc, key) => {
        acc[key] = filterDropdown.value[key];
        return acc;
      }, {});
  };

  return {
    filterDropdown,
    filtersFields,
    orderedDropdown,
  };
}
